import React from 'react';
import css from './css.module.less';

import arrayMove from 'array-move';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import ModalHoc from 'src/constrains/ModalHOC';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Modal from './NavigationSelector';
const Navigation = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { navigationList, onChange, data, droppableId, isPrimary } = props;
  const { modalOp } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;

  const handleOnSort = (obj) => {
    const { data: order } = obj;
    const { newIndex, oldIndex } = order || {};
    const _data = arrayMove(data, oldIndex, newIndex);
    onChange(_data);
  };
  const handleOnDelete = (index) => {
    const _data = [...(data || [])];
    _data.splice(index, 1);
    onChange(_data);
  };
  const handleOnChildGenerate = (data, index) => {
    const { title } = data;
    return <TextAndEditIcon name={title} />;
  };
  const handleOnAdd = () => {
    setShowModal(true);
    setModalTitle(getI18n('salesChannelContent.index.selectNavigationGroup'));
    setModalContent(
      <Modal
        onConfirm={onChange}
        onCancel={onModalCancel}
        data={data || []}
        navigationGroup={navigationList}
      />,
    );
  };
  return (
    <div className={css.dropContainer}>
      <DragNDropColumns
        disabled={!isPrimary}
        hideTitle
        hideAdd={!isPrimary}
        childGenerate={handleOnChildGenerate}
        data={data}
        droppableId={droppableId}
        onSort={handleOnSort}
        // hideAdd={hideAdd}
        onAdd={handleOnAdd}
        addText={`+ ${getI18n('salesChannelContent.index.addMenuItem')}`}
        {...(isPrimary ? { onDelete: handleOnDelete } : {})}
      />
    </div>
  );
};

export default ModalHoc(Navigation, { width: 600 });
